import React from 'react';

export const MaterialInput = ({ type = 'text', className = '', ...props }) => (
  <input type={type} className={`form-control material ${className}`} {...props} />
);
